import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export class TableSort extends Component {

  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    sort: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
  };

  render() {
    const { label, value, onChange, sort, direction } = this.props;

    return (

      <th data-el="sort" data-value={ value } onClick={onChange} className={classNames('sort', {'active': (value === sort)}, direction)}>
        { label }<span data-el="direction" data-value={ value } onClick={onChange}></span>
      </th>
    );
  }
}

export default TableSort;
